import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils/storage'
Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'Login', component: () => import('@/views/login/index') },
  { path: '/404', component: () => import('@/views/404') },
  {
    path: '/',
    name: '首页',
    component: () => import('@/views/home/index'),
    children: [
      {
        path: '',
        name: '仪表盘',
        component: () => import('@/views/home/dashboard')
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/oms',
    redirect: '/oms/orderList',
    name: '订单',
    component: () => import('@/views/home/index'),
    children: [
      {
        path: 'orderList',
        name: '订单列表',
        component: () => import('@/views/oms/order/index')
      },
      {
        path: 'deliverOrderList',
        name: '发货列表',
        component: () => import('@/views/oms/order/deliverOrderList')
      },
      {
        path: 'refundList',
        name: '退款订单',
        component: () => import('@/views/oms/order/refundList')
      },
      {
        path: 'orderDetail/:id',
        name: '订单详情',
        component: () => import('@/views/oms/order/orderDetail')
      },
      {
        path: 'deliverApply/:id',
        name: '订单发货',
        component: () => import('@/views/oms/order/deliverApply')
      },

    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/config',
    redirect: '/config/postcardHandwritingFee',
    name: '配置管理',
    component: () => import('@/views/home/index'),
    children: [
      {
        path: 'postcardHandwritingFee',
        name: '明信片手写费用',
        component: () => import('@/views/config/postcard/handwritingFee')
      },
      {
        path: 'postcardFlatMailFee',
        name: '明信片平邮费用',
        component: () => import('@/views/config/postcard/flatMailFee')
      },
      {
        path: 'postcardRegisteredMailFee',
        name: '明信片挂号信费用',
        component: () => import('@/views/config/postcard/registeredMailFee')
      },
      {
        path: 'postcardPhotoFee',
        name: '明信片照片费用',
        component: () => import('@/views/config/postcard/photoFee')
      }
    ],
    meta: { requiresAuth: true }
  },
  { path: '*', redirect: '/404' }
]

const router = new VueRouter({
  routes
})
// 导航守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!getToken()) {
      next({ name: 'Login' });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router
